import { GiDiscussion, GiTeacher } from "react-icons/gi";
import { SiCodementor } from "react-icons/si";
import Button from "../../../components/shared/Button";
import { contactPath } from "../../../components/routes/path";
import { Link } from "react-router-dom";

const WhatWeDo = () => {
  return (
    <div className="flex flex-col gap-28">
      <div className="font-[Roboto] grid sm:grid-cols-3 sm:gap-x-8 gap-5 mt-20 p-2 sm:px-14">
        <div className="flex flex-col items-center gap-5 ">
          <div className="bg-[#004C97] rounded-full p-4 ">
            <SiCodementor className="text-4xl text-white" />
          </div>
          <h2 className="font-semibold text-lg sm:text-2xl">
            PERFECT RECITATION
          </h2>
          <p className="text-sm sm:text-[17.5px] text-center leading-7">
            We provide structured program that teach the proper recitation of
            the Quran with Tajweed, ensuring students can recite fluently and
            correctly.
          </p>
        </div>
        <div className="flex flex-col items-center gap-5 ">
          <div className="bg-[#004C97] rounded-full p-4  ">
            <GiTeacher className="text-4xl text-white " />
          </div>
          <h2 className="font-semibold text-lg sm:text-2xl">
            ADVANCE RECITATION
          </h2>
          <p className="text-sm sm:text-[17.5px] text-center leading-7">
            We offer advanced programs for Huffaz who want to deepen their
            knowledge by mastering different modes of Quranic recitation
            (Qira’at) with authentic Ijazah certification.
          </p>
        </div>
        <div className="flex flex-col items-center gap-5 ">
          <div className="bg-[#004C97] rounded-full p-4 ">
            <GiDiscussion className="text-4xl text-white" />
          </div>
          <h2 className="font-semibold text-lg sm:text-2xl">
            QUALITY MEMORIZATION
          </h2>
          <p className="text-sm sm:text-[17.5px] text-center leading-7">
            Our structured Hifz (memorization) programs help children and adults
            commit the Quran to memory at their own pace, with the support of
            experienced instructors.
          </p>
        </div>
      </div>
      <div className="flex flex-col item-center text-center gap-8 p-2 sm:p-5">
        <div className="bg-[#3b76db] h-[1px] mx-auto w-[50%]"></div>
        <h2 className="font-bold text-3xl">WHAT WE DO</h2>
        <p className="text-sm sm:text-[15.5px] text-center leading-7 sm:w-[70%] mx-auto">
          At Maqraha Ul Tanzeel, we are committed to preserving and perfecting
          the recitation of the Holy Quran by providing structured learning
          opportunities for Muslims worldwide. Our goal is to ensure that every
          Muslim—regardless of age, background, or schedule—has access to
          high-quality Quranic education, from basic reading skills to advanced
          Qira’at mastery.
        </p>
        <div>
          <Link to={contactPath}>
            <Button
              btnBgColor={
                "bg-[#66b2ff] hover:bg-white sm:rounded-full hover:rounded-full hover:border hover:border-[#333333]"
              }
              btnColor={" text-white hover:text-[#333333]"}
              btnText={"Let's Talk Now"}
              padding={"px-5 py-2 transition-all  ease-in-out"}
            />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default WhatWeDo;
